export default "__VITE_ASSET__DayikTFc__"